import { DeanteData } from "../Universal/API/Context-API/AppProvider";
import type { OrderHistoryOrder, SavedOrderItem } from "./cartTypes";

export const parseNumericValue = (value: unknown) => {
  const numeric = Number(
    String(value ?? "")
      .replace(",", ".")
      .replace(/[^\d.-]/g, "")
  );

  return Number.isFinite(numeric) ? numeric : 0;
};

export const formatCurrency = (value: number) => {
  try {
    return new Intl.NumberFormat("ru-RU", {
      maximumFractionDigits: 0,
    }).format(value);
  } catch {
    return String(Math.round(value));
  }
};

export const getCartItemImage = (unit: DeanteData) => {
  const medium = unit.sliders?.medium?.[0];
  const full = unit.sliders?.full?.[0];
  return medium || full || unit.uri_small || unit.uri_full || "";
};

export const getResolvedUnitPrice = ({
  unit,
  showDiscountPrices,
}: {
  unit: DeanteData;
  showDiscountPrices: boolean;
}) => {
  const basePrice = parseNumericValue(unit.price);
  const discountPrice = parseNumericValue(unit.discounted_price);

  if (showDiscountPrices && discountPrice > 0) {
    return discountPrice;
  }

  return basePrice;
};

export const getCurrentOrderItemPrices = ({
  unit,
  showDiscountPrices,
}: {
  unit: DeanteData;
  showDiscountPrices: boolean;
}) => {
  const currentPrice = parseNumericValue(unit.price);
  const currentOptPrice = parseNumericValue(unit.discounted_price);
  const calculatedByPrice =
    showDiscountPrices && currentOptPrice > 0 ? "current_opt_price" : "current_price";

  return {
    current_price: currentPrice,
    current_opt_price: currentOptPrice,
    calculated_by_price: calculatedByPrice,
  };
};

export const getSavedOrderItemUnitPrice = ({
  item,
  showDiscountPrices,
}: {
  item: SavedOrderItem;
  showDiscountPrices: boolean;
}) => {
  if (showDiscountPrices && item.current_opt_price > 0) {
    return item.current_opt_price;
  }

  return item.current_price;
};

export const getHistoryOrderDisplayTotal = ({
  order,
  showDiscountPrices,
}: {
  order: OrderHistoryOrder;
  showDiscountPrices: boolean;
}) => {
  if (showDiscountPrices) {
    return order.saved_opt_total > 0 ? order.saved_opt_total : order.saved_rrc_total;
  }

  return order.saved_rrc_total > 0 ? order.saved_rrc_total : order.total_price;
};

export const formatOrderHistoryDate = (value?: string | null) => {
  if (!value) return "";

  const normalized = value.includes("T") ? value : value.replace(" ", "T");
  const date = new Date(normalized);

  if (Number.isNaN(date.getTime())) {
    return value;
  }

  try {
    return new Intl.DateTimeFormat("ru-RU", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    }).format(date);
  } catch {
    return value;
  }
};
